import React from "react";
import { Tooltip, TooltipProps } from "antd";
import { combineClasses } from "../../../lib/utils";
import { AnyObject } from "../../../lib/interfaces";
import { CustomOmit } from "../../../lib/types/utilityTypes/CustomOmit";
import "./DataTooltip.less";

type ComponentProps<T> = CustomOmit<TooltipProps, "overlay"> & {
  className?: string;
  dataObject: T;
  includedFields: (keyof T)[];
};

/**
 * Возвращает Tooltip с title - значениями заданных полей объекта, разделенных вертикальной линией
 */

export const DataTooltip = <T extends AnyObject>(props: ComponentProps<T>) => {
  const { className, dataObject, includedFields, ...tooltipProps } = props;

  const agreementData = includedFields.map((fieldName) => dataObject[fieldName]);

  return (
    <Tooltip
      overlayClassName={combineClasses("data-tooltip", className)}
      title={agreementData.map((item, idx) => (
        <span key={idx}>{item}</span>
      ))}
      {...tooltipProps}
    />
  );
};
